var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPotato(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5CE85"
    },
    d: "M15.496,38.5c-5.309,0-9.688-2.179-12.017-5.978c-4.744-7.738-0.204-11.791,5.053-16.484 c1.429-1.275,2.905-2.594,4.182-4.007c0.406-0.45,0.812-0.904,1.218-1.358C17.96,6.164,22.126,1.5,27.006,1.5 c1.913,0,3.829,0.684,5.857,2.091c3.216,2.231,5.137,5.674,5.553,9.958c0.595,6.115-2.007,13.143-6.627,17.904 C27.506,35.865,21.415,38.5,15.496,38.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#967A44"
    },
    d: "M27.007,2L27.007,2c1.807,0,3.63,0.655,5.571,2.002c3.906,2.71,5.06,6.713,5.34,9.595 c0.581,5.975-1.966,12.847-6.488,17.508C27.24,35.422,21.283,38,15.496,38c-5.131,0-9.356-2.092-11.591-5.739 c-4.525-7.383-0.129-11.307,4.961-15.85c1.438-1.284,2.925-2.611,4.219-4.043c0.407-0.45,0.813-0.905,1.218-1.359 C18.441,6.376,22.35,2,27.007,2 M27.006,1c-5.598,0-10.067,5.611-14.663,10.697C6.562,18.096-3.289,22.438,3.052,32.784 C5.636,37,10.34,39,15.496,39c5.763,0,12.091-2.5,16.652-7.2c7.777-8.014,10.009-22.371,1-28.62C30.938,1.647,28.907,1,27.006,1 L27.006,1z"
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#967A44"
    },
    cx: 28.5,
    cy: 11.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#967A44"
    },
    cx: 29.5,
    cy: 18.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#967A44"
    },
    cx: 17.5,
    cy: 27.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#967A44"
    },
    cx: 17.5,
    cy: 34.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#967A44"
    },
    cx: 11.5,
    cy: 31.5,
    r: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#967A44"
    },
    cx: 24,
    cy: 15,
    r: 1
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPotato);
export default __webpack_public_path__ + "static/media/potato.4ccd7e77590b6956226e3912e75c7c1a.svg";
export { ForwardRef as ReactComponent };